import { render, staticRenderFns } from "./MenuButton.vue?vue&type=template&id=0c13b5e7&scoped=true&"
var script = {}
import style0 from "./MenuButton.vue?vue&type=style&index=0&id=0c13b5e7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c13b5e7",
  null
  
)

export default component.exports